import { createPortal } from 'react-dom'
import { Link } from 'react-router-dom'

const DMCAModal = ({ onClose }: { onClose: () => void }) => {
  return createPortal(
    <div id="modal-example" className="pf-modal">
      <div className="pf-modal__dialog">
        <div className="pf-modal__content">
          <div className="pf-modal__body">
            <div className="pf-page__logo">
              <div className="pf-page__logo-content">
                <img
                  src='/logo.png'
                  alt='AllFans'
                  className='pf-page__logo-img'
                />
              </div>
            </div>
            <h2 className="pf-page__title">
              All<span>Fans</span>
            </h2>
            <div className="pf-page__descr">DMCA Policy
            <p style={{ paddingTop: '1rem' }}>Last Updated: 2025/07/29</p></div>
          <div className="pf-main-list">
            <h5 className="centered-h5">Termination of User Account</h5>
              <ol className="centered-ol">
                <li>We will terminate a user’s access to the service if, under appropriate circumstances, the user is 
                  determined to be a repeat infringer.</li>
                <li>We reserve the right to decide whether material or activity violates our <Link to="/terms" className='terms-link'>Terms of Service</Link> for 
                reasons other than copyright infringement, including child sexual abuse material (CSAM), obscenity, 
                  or excessive length. We may at any time, without prior notice, remove that material or terminate a 
                  user’s account for submitting that material in violation of our <Link to="/terms" className='terms-link'>Terms of Service</Link>.</li>
              </ol>
            <h5 className="centered-h5">Removal of Material for Which Copyright Infringement Is Claimed</h5>
            <h5 className="centered-h5">Digital Millennium Copyright Act</h5>
          
                <p>We will respond to allegations of copyright violations in accordance with the Digital Millennium 
                  Copyright Act (DMCA). The DMCA provides a process for a copyright owner to give notification to an 
                  online service provider concerning alleged copyright infringement. When an effective DMCA notification 
                  is received, the online service provider responds under this process by taking down the offending content. 
                  On taking down content under the DMCA, we will take reasonable steps to contact the owner of the removed 
                  content so that a Counternotification may be filed. On receiving a valid Counternotification, we generally 
                  restore the content in question, unless we receive notice from the DMCA Notice provider that a legal 
                  action has been filed seeking a court order to restrain the alleged infringer from engaging in the infringing 
                  activity. Our <Link to="/privacypolicy" className='terms-link'>Privacy Policy</Link> does not protect any information contained in any DMCA Counternotification.</p>
            
                <p><strong><span className="red-text">To File a DMCA Notification.</span> If you are a copyright owner or an agent of a copyright owner and believe 
                  that any Content infringes on your copyrights, you may submit a notification under the Digital Millenium 
                  Copyright Act (DMCA) by providing our copyright agent with the following information in writing (see 17 
                  U.S.C. § 512 for further detail):</strong></p>

                  <ol>
                    <li>
                      A physical or electronic signature of a person authorized to act for the owner of an exclusive 
                      right that is allegedly infringed.
                    </li>
                    <li>
                      Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single 
                      online site are covered by a single notification, a representative list of those works at that site.
                    </li>
                    <li>
                      Identification of the material that is claimed to be infringing or to be the subject of infringing 
                      activity and that is to be removed or access to which is to be disabled, and information reasonably 
                      sufficient to permit the service provider to locate the material. Providing URLs in the body of your 
                      DMCA notification is the best way to help us locate content quickly.
                    </li>
                    <li>
                      Information reasonably sufficient to permit us to contact you (the complaining party), including an address, telephone number, and, 
                      if available, an electronic mail address at which you (the complaining party) can be contacted.
                    </li>
                    <li>
                      A statement that you (the complaining party) have a good faith belief that use of the material in the manner complained 
                      of is not authorized by the copyright owner, its agent, or the law.
                    </li>
                    <li>
                      A statement that the information in the notification is accurate, and under penalty of perjury, that you 
                      (the complaining party) are authorized to act for the owner of an exclusive right that is allegedly infringed.
                    </li>
                    <li>
                      Provide information, if possible, sufficient to permit us to notify the user or users who posted the 
                      content that allegedly contains infringing material.
                    </li>
                  </ol>

                <p>You can send the DMCA Notice to our Designated Agent at:</p>
                
               <p>Innodev Solutions Inc.<br></br>
                2108 N ST, STE N<br></br>
                SACRAMENTO, CA 95816<br></br>
                dmca@allfans.com
                </p>

                <p><strong>Any person who knowingly materially misrepresents that material or an activity is infringing or that any 
                  material or activity was removed or disabled by mistake or misidentification, will be liable to us for 
                  any damages, including costs and legal fees incurred by us in removing or disabling access to the material 
                  or activity claimed to be infringing or in replacing the removed material or enabling access to it.</strong></p>
                <p><strong><span className="red-text">To File a Counternotification.</span> If you believe that your content/material that was removed or to which 
                  access was disabled is not infringing, or that you have the authorization from the copyright owner, the 
                  copyright owner’s agent, or under the law, to post and use the material, you may send a Counternotification 
                  containing the following information to our Designated Agent:</strong></p>
                    <ol>
                      <li>
                        Your physical or electronic signature;
                      </li>
                      <li>
                        Identification of the material that has been removed or to which access has been disabled and the 
                        location at which the material appeared before it was removed or access disabled;
                      </li>
                      <li>
                        A statement that you have a good faith belief that the material was removed or disabled as a 
                        result of mistake or a misidentification of the material; and
                      </li>
                      <li>
                        Your name, address, telephone number, and email address, a statement that you consent to the 
                        jurisdiction of the US district court in the state in which you reside (or the US District Court for 
                        the District of Nevada if your address is outside of the United States), and a statement that you will 
                        accept service of process from the person who provided notification of the alleged infringement to us.
                      </li>
                    </ol>
               <p>You can send the Counternotification to our Designated Agent at:</p>    
               <p>Innodev Solutions Inc.<br></br>
                2108 N ST, STE N<br></br>
                SACRAMENTO, CA 95816<br></br>
                dmca@allfans.com
               </p>
               <p><strong>Any person who knowingly materially misrepresents that material or an activity is infringing or 
                that any material or activity was removed or disabled by mistake or misidentification, will be liable 
                to us for any damages, including costs and legal fees incurred by us in removing or disabling access to the 
                material or activity claimed to be infringing or in replacing the removed material or enabling access to it.</strong></p>
          </div>
          </div>
        </div>
          <div className="pf-modal__footer">
            <div className="pf-page__social">
              <button
                type="button"
                onClick={onClose}
                className="btn btn-default"
                style={{
                  width: '100%',
                  maxWidth: '220px'
                }}
              >
                Close
              </button>
            </div>
          </div>
      </div>
    </div>, document.body
  )
}

export default DMCAModal
